import { render, staticRenderFns } from "./ItemStatistics.vue?vue&type=template&id=676d0935&scoped=true&"
import script from "./ItemStatistics.vue?vue&type=script&lang=js&"
export * from "./ItemStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ItemStatistics.vue?vue&type=style&index=0&id=676d0935&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676d0935",
  null
  
)

export default component.exports